import { Component, EventEmitter, Input, Output } from '@angular/core';


@Component({
  selector: 'app-ist-action-list-option',
  templateUrl: './ist-action-list-option.component.html',
  styleUrls: ['./ist-action-list-option.component.scss']
})
export class IstActionListOptionComponent {

  @Input() activeAction: string = '';
  @Output() clickAction = new EventEmitter();

  showTooltip: boolean = true;
  
  openContextMenu(event: any) {
    this.clickAction.emit(event);
  }

}
